import React, { FC } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { format, useIsMobile } from '../../../../../utils';
import { ExareStatus } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { UploadedFile } from '@shared/ui/file-upload';

import { Filter } from '@shared/ui';
import { RefundRequestDocument } from '@entities/refund';
import { ExchangeRefundBreadcrumb } from '../../model';
import { ExchangeRefundStates } from '../ExchangeRefundStates';
import { ExchangeRefundMobileBreadcrumbs } from '../ExchangeRefundMobileBreadcrumbs';

interface Props {
	requestId?: string;
	timeLimit?: Date;
	createDate?: Date;
	status: ExareStatus;
	comment?: string;
	documents?: RefundRequestDocument[];
	breadcrumbs?: ExchangeRefundBreadcrumb[];
	ns?: string;
}

const ExchangeRefundRequest: FC<Props> = ({
	requestId,
	timeLimit,
	createDate,
	status,
	comment,
	documents,
	breadcrumbs,
	ns = 'Refund'
}) => {
	const { t } = useTranslation(ns);

	const { ExchangeRefundRequest: theme } = useTheme('Entities').Order;

	const isMobile = useIsMobile();

	const showRequestIdWrapper = Boolean(requestId || createDate);
	const showStatusWrapper = Boolean(status || timeLimit);

	return (
		<div className={theme.root}>
			<div className={cn(theme.headerBlock, theme.block)}>
				<div className={theme.headerTop}>
					{showRequestIdWrapper && (
						<div className={theme.requestIdWrapper}>
							{/* Почему-то в новом дизайне убрали, но на всякий случай сделал заготовку */}
							{/* {!!requestId && (
								<>
									<div className={theme.requestId}>{t('Request #{{requestId}}', { requestId })}</div>

									<div className={theme.verticalLine} />
								</>
							)} */}

							{!!createDate && (
								<div className={theme.createDate}>{format(createDate, 'dd MMM yyyy HH:mm')}</div>
							)}
						</div>
					)}

					{showStatusWrapper && (
						<div className={theme.statusWrapper}>
							{status && <ExchangeRefundStates status={status} ns={ns} />}

							{!!timeLimit && (
								<>
									<div className={theme.verticalLine} />

									<div className={theme.timeLimit}>{format(timeLimit, 'dd MMM yyyy HH:mm')}</div>
								</>
							)}
						</div>
					)}
				</div>

				{!isMobile && (
					<div className={theme.breadcrumbs}>
						{breadcrumbs.map((breadcrumb, index) => (
							<Filter
								key={index}
								classes={{ root: theme.breadcrumb }}
								label={breadcrumb.label}
								onClick={() => {}}
								isSelected
							/>
						))}
					</div>
				)}

				{isMobile && (
					<ExchangeRefundMobileBreadcrumbs className={theme.mobileBreadcrumbs} breadcrumbs={breadcrumbs} />
				)}
			</div>

			{!!comment && (
				<div className={cn(theme.commentBlock, theme.block)}>
					<span className={theme.blockTitle}>{t('Your comments')}</span>
					<span className={theme.comment}>{comment}</span>
				</div>
			)}

			{!!documents?.length && (
				<div className={cn(theme.filesBlock, theme.block)}>
					<span className={theme.blockTitle}>{t('Files')}</span>
					<div className={theme.files}>
						{documents.map((document, index) => (
							<UploadedFile
								key={index}
								className={theme.file}
								name={`${document.passengerName}: ${t(document.documentType)}`}
							/>
						))}
					</div>
				</div>
			)}
		</div>
	);
};

export default ExchangeRefundRequest;
